import * as React from "react";
import { forwardRef } from "react";
const SvgPlayFilled = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 29, height: 30, viewBox: "0 0 29 30", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7.2002 4.19971L24.0002 14.9997L7.2002 25.7997V4.19971Z", fill: "current_color" }));
const ForwardRef = forwardRef(SvgPlayFilled);
export { ForwardRef as ReactComponent };
